import type { UserQueryParams } from './types';

export type UserListRequestParams = Omit<UserQueryParams, 'current'> & {
  page?: number;
};

/** 将 Ant Design 分页参数转换为 Foundation 用户接口参数。 */
export const toUserListRequestParams = (
  params: UserQueryParams = {}
): UserListRequestParams => {
  const { current, ...rest } = params;
  return {
    ...rest,
    ...(current !== undefined ? { page: current } : {}),
  };
};
